<mat-menu>
  <button (click)="preview($event)" mat-menu-item aria-label="confirmar">
    <mat-icon>pageview</mat-icon>
    <span>Visualizar solicitação</span>
  </button>
  <span>
    <button (click)="orcar()" mat-menu-item aria-label="Orçar">
      <mat-icon>edit</mat-icon>
      <span>Orçar</span>
    </button>
  </span>
  <button (click)="confirmDeleteQuote()" mat-menu-item aria-label="negar">
    <mat-icon>delete_outline</mat-icon>
    <span>Excluir</span>
  </button>
</mat-menu>
